import { SvgIcon } from '@progress/kendo-react-common';
import { Switch } from '@progress/kendo-react-inputs';
import { useEffect, useState } from 'react';
import { CheckmarkCircleOutline } from '../../../../../icons/icons';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useSettingSwitchValue } from '../../../home/hooks/settings';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsFullscreenElement() {
    const [hasPermissions, setHasPermissions] = useState(false);
    const setting = useSettingSwitchValue('startInFullscreenMode');
    const context = useSearchContext();

    useEffect(() => {
        // Chrome-specific permission, only granted if the browser is managed and the app is in AutomaticFullscreenAllowedForUrls
        // https://chromeenterprise.google/policies/?policy=AutomaticFullscreenAllowedForUrls
        navigator.permissions
            .query({
                name: 'fullscreen',
                allowWithoutGesture: true
            } as unknown as PermissionDescriptor)
            .then((status) => {
                setHasPermissions(status.state === 'granted');
            })
            .catch();
    }, []);

    return (
        <div className="d-flex justify-content-between px-3 align-items-center">
            <div>
                <MarkerText highlight={context.term}>Start in fullscreen mode</MarkerText>
                {hasPermissions && (
                    <div className="d-flex align-items-center gap-1 secondary-text">
                        <SvgIcon icon={CheckmarkCircleOutline} themeColor="success" />
                        <div>Automatic fullscreen start available</div>
                    </div>
                )}
            </div>
            <Switch {...setting} />
        </div>
    );
}
